import MultiSelectDropdown from 'components/ReusableComponents/MultiSelectDropdown'
import { hotelStatusNamesFilterable } from 'main/hotelStatuses'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import userApi from 'services/api/user'

import Dropdown from '../../../../components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from '../../../../components/ReusableComponents/ManageHotel/TextInput'
import Toggle from '../../../../components/ReusableComponents/Toggle/index'
import { parentChainNames, PMSnames } from '../../../../main/hotelBrandsAndChains'
import filterStyles from '../Filters.module.scss'

function generateDateString(period) {
  const lastDates = `Last ${period} days`

  const range = `(${moment()
    .add(-1 - period, 'days')
    .format('D MMM')} -
    ${moment().add(-1, 'days').format('D MMM')})`

  return lastDates + ' ' + range
}

const HealthCheckFilters = ({
  dispatch,
  state,
  showTelcoToggle,
  showLowOutreachToggle,
  showLowConversionsToggle,
  showHideZeroBalanceToggle,
  showHideInvalidPaymentDateToggle,
  showSubsidiaryStatus,
  showPMSFilter,
  showDateFilter,
  showCsmFilter,
  showInviteStatusFilter,
  allhotelGroups,
  allhotelChains,
  children
}) => {
  const {
    showTelcoDetails,
    showLowOutreaches,
    showLowConversions,
    hideZeroBalance,
    hideInvalidPaymentDate,
    hotelGroups,
    chains,
    brands,
    pms,
    searchString,
    timeperiod,
    subsidiaryStatus,
    csmIds,
    inviteStatusFilter
  } = state

  const { disconnected, ...pmsNamesExceptDisconnected } = PMSnames // eslint-disable-line no-unused-vars

  const csmUserId = useSelector(state => state.login.csmUserId)

  const [csmData, setCsmData] = useState([])

  useEffect(() => {
    userApi.getCustomerSuccessManagers().then(data => setCsmData(data))
  }, [])

  useEffect(() => {
    if (csmUserId) {
      dispatch({
        type: 'csmIds',
        payload: [`${csmUserId}`]
      })
    }
  }, [dispatch, csmUserId])

  return (
    <div className={filterStyles.container}>
      <div className={filterStyles.filters}>
        <Dropdown
          value={hotelGroups}
          className={filterStyles.dropdown}
          onChange={e => dispatch({ type: 'hotelGroups', payload: e.target.value })}
          options={{
            all: 'All hotel groups',
            ...allhotelGroups
          }}
        />
        <Dropdown
          className={filterStyles.dropdown}
          value={brands}
          onChange={e => dispatch({ type: 'brands', payload: e.target.value })}
          options={{
            all: 'All brands',
            ...parentChainNames
          }}
        />
        <Dropdown
          className={filterStyles.dropdown}
          value={chains}
          onChange={e => dispatch({ type: 'chains', payload: e.target.value })}
          options={{
            all: 'All chains',
            ...allhotelChains
          }}
        />
        {showPMSFilter && (
          <MultiSelectDropdown
            className={filterStyles.statusDropdown}
            itemName="PMS"
            value={pms}
            hasUnselectButton
            onChangeValue={values => dispatch({ type: 'pms', payload: values })}
            options={pmsNamesExceptDisconnected}
          />
        )}
        {showSubsidiaryStatus && (
          <MultiSelectDropdown
            className={filterStyles.statusDropdown}
            options={hotelStatusNamesFilterable}
            value={subsidiaryStatus}
            hasUnselectButton
            onChangeValue={statuses =>
              dispatch({ type: 'subsidiaryStatus', payload: statuses })
            }
            itemName="statuses"
          />
        )}
        {showDateFilter && (
          <Dropdown
            className={[filterStyles.dropdown, filterStyles.wideDropdown].join(' ')}
            value={timeperiod}
            onChange={e => dispatch({ type: 'timePeriod', payload: e.target.value })}
            options={{
              1: generateDateString(1),
              7: generateDateString(7),
              14: generateDateString(14),
              30: generateDateString(30)
            }}
          />
        )}
        {showCsmFilter && (
          <MultiSelectDropdown
            className={filterStyles.statusDropdown}
            options={Object.fromEntries(csmData.map(csm => [csm.id, csm.fullName]))}
            value={csmIds}
            hasUnselectButton
            onChangeValue={value => dispatch({ type: 'csmIds', payload: value })}
            itemName="CSM"
            itemNamePlural="CSMs"
          />
        )}
        {showInviteStatusFilter && (
          <Dropdown
            className={filterStyles.dropdown}
            value={inviteStatusFilter || 'all'}
            onChange={e =>
              dispatch({ type: 'inviteStatusFilter', payload: e.target.value })
            }
            options={{
              all: 'All invite statuses',
              1: 'Last 1 day',
              Lost3Months: '3 Mo',
              Lost6Months: '6 Mo',
              Lost9Months: '9 Mo',
              Lost12Months: '12 Mo',
              Lost15Months: '15 Mo',
              Lost15MonthsPlus: '15 Mo+',
              AfterLastVisit: 'After visit'
            }}
          />
        )}
        <TextInput
          type="search"
          className={filterStyles.searchInput}
          value={searchString}
          onChange={e => dispatch({ type: 'searchString', payload: e.target.value })}
          placeholder="Filter results"
        />
      </div>
      <div className={filterStyles.toggleContainer}>
        {showTelcoToggle && (
          <Toggle
            label="Show telecom details"
            checked={showTelcoDetails}
            handleChange={e =>
              dispatch({ type: 'showTelcoDetails', payload: e.target.checked })
            }
            className={filterStyles.lowResultToggle}
          />
        )}
        {showLowOutreachToggle && (
          <Toggle
            label="Low outreaches"
            checked={showLowOutreaches}
            handleChange={e =>
              dispatch({ type: 'showLowOutreaches', payload: e.target.checked })
            }
            className={filterStyles.lowResultToggle}
          />
        )}
        {showLowConversionsToggle && (
          <Toggle
            label="Low conversions"
            checked={showLowConversions}
            handleChange={e =>
              dispatch({ type: 'showLowConversions', payload: e.target.checked })
            }
            className={filterStyles.lowResultToggle}
          />
        )}
        {showHideZeroBalanceToggle && (
          <Toggle
            label="Hide zero balance"
            checked={hideZeroBalance}
            handleChange={e =>
              dispatch({ type: 'hideZeroBalance', payload: e.target.checked })
            }
            className={filterStyles.lowResultToggle}
          />
        )}
        {showHideInvalidPaymentDateToggle && (
          <Toggle
            label="Hide invalid payment date"
            checked={hideInvalidPaymentDate}
            handleChange={e =>
              dispatch({ type: 'hideInvalidPaymentDate', payload: e.target.checked })
            }
            className={filterStyles.lowResultToggle}
          />
        )}
        {children}
      </div>
    </div>
  )
}

export default HealthCheckFilters
